/**
 * Created by Ding on 13/04/2017.
 */

import React, { Component, PropTypes } from 'react';
import cookie from 'react-cookie';
import { message } from 'antd';

import RecommendCandidateForm from './RecommendCandidateForm';
import { ajaxPost } from '../../utils/ajax';


export default class RecommendCandidate extends Component {

    static defaultProps = {
        positionId: '',
    };

    static propTypes = {
        params: PropTypes.object.isRequired,
        positionId: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        parseResult: {},
        loading: false,
        submittable: true,
    };

    recommendCandidate = (params, callback, failback) => {
        if (!this.state.submittable) {
            message.info('请重新上传简历后再试');
            return;
        }
        const newParams = Object.assign({}, params);
        delete newParams.resume;
        newParams.jdId = this.props.params.positionId;
        newParams.recommender = cookie.load('cookie_user_en');
        newParams.channelId = 300;
        newParams.cacheKey = this.state.parseResult.cacheKey;
        newParams.fileName = this.state.parseResult.fileName;
        newParams.uri = this.state.parseResult.uri;
        newParams.isExternal = true;
        newParams.parseSuccess = this.state.parseResult.parseSuccess;
        newParams.remark = '';

        ajaxPost('/recruit/api/hunter/submit', newParams, ({ data }) => {
            if (data.errorNo !== 0) {
                message.error(data.errorInfo);
            } else {
                message.success('推荐候选人成功！', 1, () => this.props.history.goBack());
            }
            if (callback) {
                callback(data);
            }
        }, (data) => {
            if (failback) {
                failback(data);
            }
        });
    };

    parseResume = ({ parseResult, submittable }) => {
        this.setState({
            parseResult,
            submittable: submittable
        });
        // this.setState({
        //     loading: true,
        // });
        // const newParams = {
        //     fileName,
        //     uri,
        //     channelId: 300,
        // };
        // ajaxPost('/recruit/api/common/parse', newParams, ({ data }) => {
        //     if (data.errorNo !== 0) {
        //         message.error(data.errorInfo);
        //         this.setState({
        //             loading: false,
        //             submittable: true,
        //         });
        //     } else {
        //         this.setState({
        //             parseResult: {
        //                 ...data,
        //                 fileName,
        //             },
        //             loading: false,
        //             submittable: true,
        //         });
        //     }
        // }, ({ meta }) => {
        //     message.error((meta && meta.message) || '网络请求失败，请稍后重试！');
        //     this.setState({
        //         loading: false,
        //         submittable: false,
        //     });
        // });
    };

    render() {
        return (
            <div>
                <p className="detail-page-title">推荐候选人</p>
                <RecommendCandidateForm
                    ref={(node) => {
                        this.candidateForm = node;
                    }}
                    loading={this.state.loading}
                    handleSubmit={this.recommendCandidate}
                    handleUploadSucceed={this.parseResume}
                    positionId={this.props.params.positionId}
                    history={this.props.history}
                />
            </div>
        );
    }
}

// TODO：resume upload 完善
